import Typography from "../../designComponents/Typography";
import {
  ButtonsSection,
  LabelText,
  ValueText,
} from "../Properties/Details/styles";
interface PromoteProperty {
  perDayRate: number;
  weeklyDiscountRate: number;
  monthlyDiscountRate: number;
  viewCountInterval?: number;
}

interface PlatformFee {
  percentageFee: number;
  flatFee: number;
  currency: string;
  paymentMethod?: string;
}

export interface PropertyPromotion {
  promoteProperty: PromoteProperty;
  platformFee: PlatformFee;
  _id: string;
}

function ViewPromos({
  globalSettingsData,
  handleDelete,
}: {
  globalSettingsData: PropertyPromotion;
  handleDelete: (id: string) => void;
}) {
  if (!globalSettingsData) {
    return (
      <div>
        <Typography>No Settings Data</Typography>
      </div>
    );
  }
  console.log(globalSettingsData);
  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          borderBottomWidth: 1,
          borderBottomStyle: "dashed",
          display: "flex",
          flexDirection: "row",
          width: "100%",
          paddingBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", width: "100%", flexDirection: "column" }}
        >
          <LabelText style={{ marginBottom: 8 }}>Property Promo Fee</LabelText>
          <ButtonsSection>
            <LabelText>Per Day Rate</LabelText>
            <ValueText>
              €{globalSettingsData?.promoteProperty?.perDayRate.toFixed(2)}
            </ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Weekly Discount</LabelText>
            <ValueText>
              {globalSettingsData?.promoteProperty?.weeklyDiscountRate}%
            </ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Monthly Discount</LabelText>
            <ValueText>
              {globalSettingsData?.promoteProperty?.monthlyDiscountRate}%
            </ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>View Count Interval</LabelText>
            <ValueText>
              {globalSettingsData?.promoteProperty?.viewCountInterval} / hrs
            </ValueText>
          </ButtonsSection>
        </div>
      </div>
    </div>
  );
}

export default ViewPromos;
